var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67212 20.6668L4.99961 21.9918C5.41442 23.7143 6.32047 24.5977 8.12164 24.5977H19.8783C21.6905 24.5977 22.5856 23.7364 23.0113 21.9918L23.3388 20.6668H4.67212ZM4.31189 19.154H23.7099L25.7621 10.6519L24.867 10.133L19.8347 13.843C19.4635 14.108 19.2125 14.0086 19.005 13.7105L14.2674 6.46711L13.7435 6.44503L8.96218 13.7436C8.77661 14.0307 8.55828 14.1191 8.18713 13.854L3.25302 10.2103L2.20507 10.4863L4.31189 19.154ZM2.60897 12.8602C4.04991 12.8602 5.20701 11.6788 5.20701 10.2103C5.20701 8.77484 4.04991 7.58232 2.60897 7.58232C1.16803 7.58232 0 8.76379 0 10.2103C0 11.6788 1.17894 12.8602 2.60897 12.8602ZM14.0055 8.26691C15.4355 8.26691 16.6035 7.08545 16.6035 5.62793C16.6035 4.1925 15.4355 3 14.0055 3C12.5536 3 11.3965 4.18147 11.3965 5.62793C11.3965 7.08545 12.5645 8.26691 14.0055 8.26691ZM25.391 12.8602C26.8211 12.8602 28 11.6788 28 10.2103C28 8.76379 26.832 7.58232 25.391 7.58232C23.961 7.58232 22.793 8.77484 22.793 10.2103C22.793 11.6788 23.961 12.8602 25.391 12.8602Z",
    fill: "#FF9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.6fa03783ade89678b572dc71974ceb2b.svg";
export { ForwardRef as ReactComponent };